import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Form, Field } from 'react-final-form';
import { TextField, Checkbox, Radio, Select } from 'final-form-material-ui';
import {
  Typography,
  Paper,
  Switch,
  Grid,
  Button,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  Divider,
  CircularProgress,
} from '@material-ui/core';
import { getTag, putTag, createTag } from '../../../business/actions/tags'
import { validateFields } from '../../../utils'
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeading from '../../../components/ui/PageHeading';
const testData = { "text": "Booster" }
export default function Create(props) {
  const history = useHistory();
  const tag_id = props.match.params?.tag_id || null
  const [busy, setBusy] = useState(false)
  const [data, setData] = useState(process.env.NODE_ENV === "development" ? testData : {})
  useEffect(() => {
    if (tag_id) getTag(tag_id).then(setData)
  }, [tag_id])
  const validate = values => validateFields(values, ["text"])
  const onSubmit = (values) => {
    if (tag_id) {
      putTag(tag_id, values)
        .then(response => { toast('Tag updated.'); setTimeout(history.goBack, 1000)  })
        .catch(error => toast(error.response.data?.message || `Tag is not updated. Unexpected error`))
        .finally(() => { setBusy(false) })
    }
    else {
      createTag(values)
        .then(response => { toast('Tag created.'); setTimeout(history.goBack, 1000)  })
        .catch(error => toast(error.response.data?.message || "Tag is not created. Unexpected error"))
        .finally(() => { setBusy(false) })
    }
    return true;
  }
  return (
    <div className={"form-wrapper"}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ text: data?.text || "Marketing", }}
        validate={validate}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper>
              <PageHeading title={`${tag_id ? 'Edit' : 'Create'} Tag`} />
              <Divider />
              <div style={{ padding: 16 }}>
                <Grid container alignItems="flex-start" spacing={2}>
                  <Grid item xs={12}>
                    <Field name="text" fullWidth required component={TextField} type="text" label="Tag" />
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button type="button" variant="contained" onClick={() => form.reset()} disabled={submitting || pristine}>
                      Reset
                    </Button>
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button variant="contained" color="primary" type="submit" disabled={submitting || pristine}>
                      {tag_id ? 'Update' : 'Submit'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </form>
        )}
      />
      {busy ? <div className='busy-progress-circular'><CircularProgress /></div> : null}
    </div>
  );
}